export default {"src":"/_next/static/media/SPRX.4f6a3ed7.svg","height":18,"width":18};